import { z } from 'zod';

export const NotificationReadSchema = z.object({
  id: z.string(),
  notification_type: z.string(),
  sent_at: z.string(),
  read: z.boolean(),
  title: z.string(),
  body: z.string(),
  deep_link_data: z
    .record(z.string(), z.unknown())
    .nullish()
    .transform((value) => value ?? {}),
});

export const NotificationResponseSchema = z.object({
  page: z.number(),
  total_pages: z.number(),
  total_notifications: z.number(),
  unread_notifications: z.number(),
  data: z.array(NotificationReadSchema),
});

export const NotificationPreferenceReadSchema = z.object({
  key: z.string().optional(),
  opt_in: z.boolean(),
  preferred_channels: z.array(z.string()),
  cooldown_seconds: z.number(),
  default_threshold: z.number().nullable(),
  threshold: z.number().nullable(),
  threshold_key: z.string().nullable(),
  threshold_constraint: z.string().nullable(),
  description: z.string(),
});

export const NotificationPreferenceResponseSchema = z.object({
  page: z.number(),
  total_pages: z.number(),
  data: z.record(z.string(), NotificationPreferenceReadSchema),
});

// ── Inferred types ────────────────────────────────────────────────────────────

export type NotificationRead = z.infer<typeof NotificationReadSchema>;
export type NotificationResponse = z.infer<typeof NotificationResponseSchema>;
export type NotificationPreferenceRead = z.infer<
  typeof NotificationPreferenceReadSchema
>;
export type NotificationPreferenceResponse = z.infer<
  typeof NotificationPreferenceResponseSchema
>;

/** Convenience alias — a map of notification type keys to their preference objects. */
export type NotificationPreferenceType = Record<
  string,
  NotificationPreferenceRead
>;

export interface NotificationPreferenceUpdate {
  notification_preferences: Record<
    string,
    Partial<Omit<NotificationPreferenceRead, 'key'>>
  >;
}
